import i18next from "i18next";

// Número único de WhatsApp da Verzel. Formato internacional sem o zero nacional
// do 0800: "0800 558 0066" -> "558005580066". Importe esta constante em vez de
// ler NEXT_PUBLIC_WHATSAPP direto: antes o número vivia na env e cravado à mão
// no `locations` abaixo, os dois divergiram, e o valor da env ficou com um zero
// a mais ("5508005580066") sem que nada quebrasse de forma visível.
// O fallback cobre dev local, onde não existe .env.
export const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPP || "558005580066";

const whatsappLink = () => {
	const whatsappMessage =
		i18next.t("blog.contactSection.whatsappMessage") ||
		"Eu preciso de suporte da Verzel!";
	const message = encodeURIComponent(whatsappMessage);
	return `https://wa.me/${whatsappNumber}?text=${message}`;
};

export const socialNetworks = {
	linkedin: "https://www.linkedin.com/company/verzeloficial/",
	instagram: "https://www.instagram.com/verzel.tech/",
	whatsapp: whatsappLink,
	x: "#",
};

export const utilityLinks = {
	// TEMPORÁRIO: "Trabalhe conosco" redirecionado para o formulário de contato.
	// Reverter para a URL do umentor abaixo quando voltar ao normal:
	// "https://painel.umentor.com.br/inteligente_novos/?con_cod=por467117&pla=5"
	workWithUs: "/#contact-us",
};

// "Trabalhe conosco" ora aponta para o umentor (externo), ora para a âncora do
// formulário (interno). Abrir âncora interna em nova aba não faz sentido, então
// os props do link são derivados do próprio destino: quando o link voltar a ser
// o umentor, o target="_blank" volta sozinho, sem mexer nos call sites.
export const workWithUsLinkProps = /^https?:\/\//.test(utilityLinks.workWithUs)
	? { target: "_blank", rel: "noopener noreferrer" }
	: {};

export const phoneNumbers = {
	"rj-sp": "0800 558 0066",
	"br": "+55 11 93292-3563",
	"de-berlim": "+49 1512 8787315",
	"pt-lisboa": "+55800 558 0066",
};
